//If you want cookie consent
// import "./modules/cookie-consent";

//If you need a class to be toggled on a different element
// import "./modules/toggle";

//If you need to do something when its in/out of the viewport
// import "./modules/intersects";

// import Swiper JS
import Swiper, { Autoplay, Pagination } from 'swiper';
// import Swiper styles
import 'swiper/css';
Swiper.use([Autoplay, Pagination]);

var googleMapLoaded = false;
window.addEventListener('scroll', function () {
	if (
		googleMapLoaded === false &&
		window.scrollY >
			document.querySelector('#map').getBoundingClientRect().top -
				window.innerHeight
	) {
		googleMapLoaded = true;
		const script = document.createElement('script');
		script.type = 'text/javascript';
		script.src =
			'https://maps.googleapis.com/maps/api/js?key=AIzaSyAHRJrksebsb0Tu0rgHevRPIHvtPvLT4rc&callback=initMap&libraries=&v=weekly';
		document.body.appendChild(script);
	}
});

const swiper = new Swiper('.swiper', {
	// Optional parameters

	direction: 'horizontal',
	autoplay: {
		delay: 4000,
		disableOnInteraction: false,
	},
	pagination: {
		el: '.swiper-pagination',
		dynamicBullets: true,
		type: 'bullets',
	},
	breakpoints: {
		768: {
			slidesPerView: 3,
			enabled: false,
			pagination: false,
		},
	},
});

const heroSlider = new Swiper('.hero', {
	// Optional parameters
	watchOverflow: true,
	direction: 'horizontal',
	loop: true,
	autoplay: {
		delay: 4000,
		disableOnInteraction: false,
	},
});

const SpecialOfferSlider = new Swiper('.special-offer-slider', {
	// Optional parameters

	direction: 'horizontal',
	autoplay: {
		delay: 4000,
		disableOnInteraction: false,
	},
	pagination: {
		el: '.swiper-pagination',
		type: 'bullets',
	},
});

const BenefitsSlider = new Swiper('.benefits-slider', {
	// Optional parameters

	direction: 'horizontal',
	slidesPerView: 1,
	autoplay: {
		delay: 4000,
		disableOnInteraction: false,
	},

	breakpoints: {
		1024: {
			slidesPerView: 3,
			spaceBetween: 30,
			pagination: {
				el: '.swiper-pagination',
				type: 'bullets',
				clickable: true,
			},
		},
	},
});

const RoomHireSlider = new Swiper('.room-hire-slider', {
	// Optional parameters

	direction: 'horizontal',
	slidesPerView: 1,
	autoplay: {
		delay: 4000,
		disableOnInteraction: false,
	},

	breakpoints: {
		1024: {
			slidesPerView: 3,
			spaceBetween: 30,
			pagination: {
				el: '.swiper-pagination',
				type: 'bullets',
				clickable: true,
			},
		},
	},
});

const RulesSlider = new Swiper('.rules-slider', {
	// Optional parameters

	direction: 'horizontal',
	slidesPerView: 1,
	autoplay: {
		delay: 4000,
		disableOnInteraction: false,
	},
	pagination: {
		el: '.swiper-pagination',
		type: 'bullets',
		clickable: true,
	},

	breakpoints: {
		1024: {
			slidesPerView: 3,
		},
	},
});

document.getElementById('hamburger').addEventListener('click', function () {
	document.getElementById('menu').classList.toggle('active');
	document.getElementById('hamburger').classList.toggle('is-active');
	document.getElementById('site-content').classList.toggle('hide-all');
	document.getElementById('site-footer').classList.toggle('hide-all');
});

// close menu on esc
document.addEventListener('keyup', function (e) {
	// if escape key is pressed
	if (e.key === 'Escape') {
		// close the menu
		document.getElementById('hamburger').classList.remove('is-active'),
			document.getElementById('menu').classList.remove('active'),
			document.getElementById('site-content').classList.remove('hide-all');
		document.getElementById('site-footer').classList.toggle('hide-all');
	}
});

window.$ = jQuery;
let newPage = 1;
$('#load-more').on('click', function () {
	$(this).prop('disabled', true);
	loadMore(newPage + 1);
	newPage++;
});
function loadMore(paged) {
	$.ajax({
		type: 'POST',
		url: '/wp-admin/admin-ajax.php',
		dataType: 'json',
		data: {
			action: 'weichie_load_more',
			paged,
		},
		success: function (res) {
			$('#load-more').prop('disabled', false);
			if (paged >= res.max) {
				$('#load-more').hide();
			}
			$('.events-list').append(res.html);
		},
	});
}

let currentdate = new Date();
currentdate.getDate(); // get current date
const monthNames = [
	'January', // 00
	'February', // 01
	'March', // 02
	'April', // 03
	'May', // 04
	'June', // 05
	'July', // 06
	'August', // 07
	'September', // 08
	'October', // 09
	'November', // 10
	'December', // 11
];

monthNames[currentdate.getMonth()]; // get current month

function toggleButtonEnable() {
	$('[id^="full_date"][data-events="false"]').prop('disabled', true);
	$('[id^="full_date"][data-events="true"]').prop('disabled', false);
}

toggleButtonEnable();

$('#previous-week').on('click', function () {
	$(this).prop('disabled', true);
	$.ajax({
		type: 'POST',
		url: '/wp-admin/admin-ajax.php',
		dataType: 'json',
		data: {
			action: 'date_changer',
			direction: 'previous',
			current_date: currentdate.getTime(),
		},

		success: function (res) {
			$('#previous-week').prop('disabled', false);
			$('#day1').html(res.day1.date);
			$('#month1').html(res.day1.month);
			$('#full_date1').attr('data-date', res.day1.full_date);
			$('#full_date1').attr('data-events', res.day1.has_events);

			$('#day2').html(res.day2.date);
			$('#month2').html(res.day2.month);
			$('#full_date2').attr('data-date', res.day2.full_date);
			$('#full_date2').attr('data-events', res.day2.has_events);

			$('#day3').html(res.day3.date);
			$('#month3').html(res.day3.month);
			$('#full_date3').attr('data-date', res.day3.full_date);
			$('#full_date3').attr('data-events', res.day3.has_events);

			$('#day4').html(res.day4.date);
			$('#month4').html(res.day4.month);
			$('#full_date4').attr('data-date', res.day4.full_date);
			$('#full_date4').attr('data-events', res.day4.has_events);

			$('#day5').html(res.day5.date);
			$('#month5').html(res.day5.month);
			$('#full_date5').attr('data-date', res.day5.full_date);
			$('#full_date5').attr('data-events', res.day5.has_events);

			$('#day6').html(res.day6.date);
			$('#month6').html(res.day6.month);
			$('#full_date6').attr('data-date', res.day6.full_date);
			$('#full_date6').attr('data-events', res.day6.has_events);

			$('#day7').html(res.day7.date);
			$('#month7').html(res.day7.month);
			$('#full_date7').attr('data-date', res.day7.full_date);
			$('#full_date7').attr('data-events', res.day7.has_events);

			currentdate.setDate(currentdate.getDate() - 7);

			toggleButtonEnable();
		},
	});
});

$('#next-week').on('click', function () {
	$(this).prop('disabled', true);
	$.ajax({
		type: 'POST',
		url: '/wp-admin/admin-ajax.php',
		dataType: 'json',
		data: {
			action: 'date_changer',
			direction: 'next',
			current_date: currentdate.getTime(),
		},

		success: function (res) {
			$('#next-week').prop('disabled', false);
			$('#day1').html(res.day1.date);
			$('#month1').html(res.day1.month);
			$('#full_date1').attr('data-date', res.day1.full_date);
			$('#full_date1').attr('data-events', res.day1.has_events);

			$('#day2').html(res.day2.date);
			$('#month2').html(res.day2.month);
			$('#full_date2').attr('data-date', res.day2.full_date);
			$('#full_date2').attr('data-events', res.day2.has_events);

			$('#day3').html(res.day3.date);
			$('#month3').html(res.day3.month);
			$('#full_date3').attr('data-date', res.day3.full_date);
			$('#full_date3').attr('data-events', res.day3.has_events);

			$('#day4').html(res.day4.date);
			$('#month4').html(res.day4.month);
			$('#full_date4').attr('data-date', res.day4.full_date);
			$('#full_date4').attr('data-events', res.day4.has_events);

			$('#day5').html(res.day5.date);
			$('#month5').html(res.day5.month);
			$('#full_date5').attr('data-date', res.day5.full_date);
			$('#full_date5').attr('data-events', res.day5.has_events);

			$('#day6').html(res.day6.date);
			$('#month6').html(res.day6.month);
			$('#full_date6').attr('data-date', res.day6.full_date);
			$('#full_date6').attr('data-events', res.day6.has_events);

			$('#day7').html(res.day7.date);
			$('#month7').html(res.day7.month);
			$('#full_date7').attr('data-date', res.day7.full_date);
			$('#full_date7').attr('data-events', res.day7.has_events);

			currentdate.setDate(currentdate.getDate() + 7);

			toggleButtonEnable();
		},
	});
});

const dateButtons = document.querySelectorAll('.date-button');
for (let i = 0; i < dateButtons.length; i++) {
	dateButtons[i].addEventListener('click', function () {
		const date = this.getAttribute('data-date');

		$.ajax({
			type: 'POST',
			url: '/wp-admin/admin-ajax.php',
			dataType: 'json',
			data: {
				action: 'day_changer',
				filter_date: date,
			},

			success: function (res) {
				$('#event-list').html(res);
			},
		});
	});
}

const categroyButtons = document.querySelectorAll('.category-button');
for (let i = 0; i < categroyButtons.length; i++) {
	categroyButtons[i].addEventListener('click', function () {
		const catergory = this.getAttribute('data-category');

		$.ajax({
			type: 'POST',
			url: '/wp-admin/admin-ajax.php',
			dataType: 'json',
			data: {
				action: 'category_changer',
				filter_category: catergory,
			},
			success: function (res) {
				$('#gallery-list').html(res);
			},
		});
	});
}
